import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getTimestamp, getAudit
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from '../system-message/SystemMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { generateSenderKeyFromMessageAudit } from 'conversations-message-history/senders/operators/generateSenderKeyFromMessageAudit';
// @ts-expect-error module not typed
import { hasThreadBeenClosed } from 'conversations-message-history/thread-status-update/operators/hasThreadBeenClosed';
// @ts-expect-error module not typed
import { hasThreadBeenOpened } from 'conversations-message-history/thread-status-update/operators/hasThreadBeenOpened';
import { getType } from 'conversations-message-history/audit/operators/auditGetters';
import { getAgentIdFromAudit } from 'conversations-message-history/audit/operators/getAgentIdFromAudit';
import { MANUAL, SYSTEM_TEST, VISITOR } from 'conversations-message-history/audit/constants/auditTypes';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { EditIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const StatusUpdateSystemMessage = ({
  message,
  senders,
  userId,
  ungatedForThreadMessagesUIImprovements
}) => {
  const audit = getAudit(message);
  const agentId = getAgentIdFromAudit(audit);
  const isCurrentAgent = agentId === userId;
  let messageText;
  if (hasThreadBeenClosed(message)) {
    const auditType = getType(audit);
    if (auditType === 'SYSTEM_AUTOMATIC' || auditType === SYSTEM_TEST) {
      messageText = 'conversations-inbox-message-history.status.threadClosed';
    } else {
      messageText = isCurrentAgent ? 'conversations-inbox-message-history.status.threadClosedByCurrentAgent' : 'conversations-inbox-message-history.status.threadClosedBy';
    }
  } else if (hasThreadBeenOpened(message)) {
    const auditType = getType(audit);
    const showMessage = auditType && (auditType === MANUAL || auditType === VISITOR);
    if (showMessage) {
      messageText = isCurrentAgent ? 'conversations-inbox-message-history.status.threadReopenedByCurrentAgent' : 'conversations-inbox-message-history.status.threadReopenedBy';
    } else {
      messageText = null;
    }
  }
  if (!messageText) {
    return null;
  }
  const updaterKey = generateSenderKeyFromMessageAudit(message);
  const updatedSender = senders.get(updaterKey);
  const agentName = isCurrentAgent ? undefined : /*#__PURE__*/_jsx(FullSenderName, {
    sender: getData(updatedSender)
  });
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description:
    /*#__PURE__*/
    // eslint-disable-next-line conversations/no-dynamic-i18n
    _jsx(FormattedReactMessage, {
      message: messageText,
      options: {
        agentName
      }
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      size: "400",
      icon: EditIcon
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
StatusUpdateSystemMessage.displayName = 'StatusUpdateSystemMessage';
export default StatusUpdateSystemMessage;